import { useState } from 'react';
import { registerUserService } from '../../services/authService';

export const useRegisterUser = () => {
    const [loading, setLoading] = useState(false);

    const registerUser = async (newUserDTO: any) => {
        setLoading(true);
        try {
            const response = await registerUserService(newUserDTO);
            return response.data.message;
        } catch (error: any) {
            throw error;
        } finally {
            setTimeout(() => setLoading(false), 600);
        }
    };

    return { registerUser, loading };
};
